// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import Text from "components/typography/Text";

// #####################################################

export const StyledSelectorLabel = styled(({ ...props }) => (
	<Text small {...props} />
))`
	position: relative;
	pointer-events: none;
	z-index: 3;
`;

// #####################################################
